import { jsonb, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const atsConfigs = pgTable(
  'ats_configs',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    provider: text('provider', { enum: ['teamtailor', 'recman'] }).notNull(),
    apiKey: text('api_key').notNull(),
    stageMapping: jsonb('stage_mapping').notNull(),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [unique('ats_configs_org_id_unique').on(t.orgId), tenantOrgIsolationPolicy()]
).enableRLS();
